module.exports = __webpack_public_path__ + "media/images/design/common/images/btn_ml-445913c33bf4db87ce8f620cd0dbea1b.jpg";